import { searchByQuery } from '@/helpers/search';
import { isHorseAvailable } from '@/helpers/dataManager';

export const defaultActiveState = {
  availability: null,
  horseType: null,
  horseCategory: null,
  sizeCategory: null,
  unassignedHorses: false,
  unusedRides: false,
  presentHorses: true
};

export default {
  namespaced: true,
  state: {
    active: { ...defaultActiveState },
    unavailableHorsesSessionTypes: ['SOINS', 'ABSENCE', 'FERMETURE', 'REPOS']
  },
  mutations: {
    setFilters (state, { key, value }) {
      state.active = { ...state.active, [key]: value };
    },
    resetFilters (state) {
      state.active = { ...defaultActiveState };
    }
  },
  getters: {
    byAvailability: (state, getters, rootState, rootGetters) => horses => {
      if (!state.active.availability) {
        return horses;
      }
      const { dailySessions } = rootGetters;

      switch (state.active.availability) {
        case 'available':
          return horses.filter(horse => {
            const sessionsWithHorse = dailySessions.filter(session => (session.horses || []).some(h => h.uuid === horse.uuid));
            return !sessionsWithHorse.some(session => state.unavailableHorsesSessionTypes.includes(session.type));
          });
        case 'unavailable':
          return horses.filter(horse => dailySessions.some(session => state.unavailableHorsesSessionTypes.includes(session.type) && (session.horses || []).some(h => h.uuid === horse.uuid)));
        default:
          return horses;
      }
    },
    byHorseType: state => horses => {
      if (!state.active.horseType) {
        return horses;
      }
      return horses.filter(horse => horse.horse_type === state.active.horseType);
    },
    byCategory: state => horses => {
      if (!state.active.horseCategory) {
        return horses;
      }
      return horses.filter(horse => horse.horse_category === state.active.horseCategory);
    },
    bySizeCategory: state => horses => {
      if (!state.active.sizeCategory) {
        return horses;
      }
      return horses.filter(horse => horse.horse_size_category === state.active.sizeCategory);
    },
    byUnassignedHorses: (state, getters, rootState, rootGetters) => horses => {
      if (!state.active.unassignedHorses) {
        return horses;
      }
      const sessions = rootGetters.filteredRepriseTabSessions;
      const dailyUsedHorses = sessions.flatMap(session => (session.horses || []));
      return horses.filter(horse => !dailyUsedHorses.some(h => h.uuid === horse.uuid));
    },
    byUnusedRides: (state, getters, rootState, rootGetters) => horses => {
      if (!state.active.unusedRides) {
        return horses;
      }
      const sessions = rootGetters.filteredRepriseTabSessions;
      return horses.filter(horse => (sessions || []).some(session => (session.horses || []).some(h => h.uuid === horse.uuid) && !(session.participants || []).some(p => p.horse === horse.uuid) && !(session.instructors || []).some(i => i.horse === horse.uuid)));
    },
    byPresentHorses: state => horses => {
      if (!state.active.presentHorses) {
        return horses;
      }
      return horses.filter(horse => isHorseAvailable(horse));
    },
    byNavbarSearch: () => horses => searchByQuery('horse', horses),
    byNoOwners: () => horses => horses.filter(horse => !horse.owners || !horse.owners.length),
    repriseTab: (state, getters) => horses => {
      if (!horses || !horses.length) return [];
      const pipeline = [getters.byAvailability, getters.byHorseType, getters.byCategory, getters.bySizeCategory, getters.byUnassignedHorses, getters.byUnusedRides, getters.byNavbarSearch, getters.byNoOwners, getters.byPresentHorses];
      return pipeline.reduce((acc, filter) => filter(acc), horses);
    }
  }
};
